"use client"

import { useParams, useRouter } from "next/navigation"
import { useState } from "react"

const SearchBox = ({ className }: { className?: string }) => {
  const router = useRouter()
  const { countryCode } = useParams() as { countryCode: string }
  const [q, setQ] = useState("")
  const [focused, setFocused] = useState(false)

  const submit = () => {
    const term = q.trim()
    const cc = countryCode || "us"
    router.push(term ? `/${cc}/store?q=${encodeURIComponent(term)}` : `/${cc}/store`)
  }

  return (
    <div
      className={`flex items-center bg-card rounded-[10px] px-3 py-2 transition-[width,border-color] duration-200 ${
        focused ? "border-clay w-56" : "border-line w-44"
      } border ${className ?? ""}`}
    >
      <button
        type="button"
        aria-label="Search"
        onClick={submit}
        className="shrink-0 text-muted hover:text-ink transition-colors"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="7" />
          <path d="m21 21-4.3-4.3" />
        </svg>
      </button>
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && submit()}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder="Search tile…"
        className="bg-transparent border-none outline-none pl-2 text-sm w-full text-ink placeholder:text-muted"
      />
    </div>
  )
}

export default SearchBox
